export const customQuantityWarning =
  `This quantity was set manually.
   Any change to the estimate's items will cause re-calculation, and this quantity will be reset.`;
